import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export type DataFetchStrategy = 'online' | 'offline-first' | 'cache-only';

interface DataFetchStrategyContextType {
  strategy: DataFetchStrategy;
  setStrategy: (strategy: DataFetchStrategy) => void;
}

const DataFetchStrategyContext = createContext<DataFetchStrategyContextType | undefined>(undefined);

export function DataFetchStrategyProvider({ children }: { children: ReactNode }) {
  const [strategy, setStrategyState] = useState<DataFetchStrategy>('online');

  const setStrategy = useCallback((newStrategy: DataFetchStrategy) => {
    setStrategyState(newStrategy);
  }, []);

  return (
    <DataFetchStrategyContext.Provider value={{ strategy, setStrategy }}>
      {children}
    </DataFetchStrategyContext.Provider>
  );
}

export function useDataFetchStrategy(): DataFetchStrategyContextType {
  const context = useContext(DataFetchStrategyContext);
  if (context === undefined) {
    throw new Error('useDataFetchStrategy must be used within a DataFetchStrategyProvider');
  }
  return context;
}
